import React from 'react'
import AD from 'react-google-publisher-tag';
import {get} from 'lodash'

import './style.css'

class BannerAd extends React.Component {
	render(){
		return(
			<div className="banner-ad-container">
        <AD path={get(this.props.data, 'metadataMap.adTag')} dimensions={[[970,90],[728,90],[320,50]]}/>
			</div>
    )
	}
}

export default BannerAd